import React, { useState } from 'react'
import DemandCurve from './DemandCurve'
import SupplyCurve from './SupplyCurve'
import DemandCurveEmulator from './DemandCurveEmulator'
import SupplyCurveEmulator from './SupplyCurveEmulator'
import DemandCurveMobile from './DemandCurveMobile'
import DemandCurveMobileSteep from './DemandCurveMobileSteep'
import DemandCurveMobileFlat from './DemandCurveMobileFlat'
import SupplyCurveMobile from './SupplyCurveMobile'
import SupplyCurveMobileSteep from './SupplyCurveMobileSteep'
import SupplyCurveMobileFlat from './SupplyCurveMobileFlat'
import styles from './styles'
import price from '../../../../images/price.svg'
import quantity from '../../../../images/quantity.svg'
import { emulatorScreen, mobileScreen } from "../../../../utils/styleUtils"
import { useTheme } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core'
import withStyles from '@material-ui/core/styles/withStyles'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import DemandCurveSteep from './DemandCurveSteep'
import SupplyCurveFlat from './SupplyCurveFlat'
import DemandCurveFlat from './DemandCurveFlat'
import SupplyCurveSteep from './SupplyCurveSteep'

const LineDotBothHandler = (props) => {

  const {
    showDragMessage,
    dottedLineLabels,
    classes,
    question,
    ...otherProps
  } = props

  const theme = useTheme();
  const isEmulator = useMediaQuery(emulatorScreen(theme));
  const isMobile = useMediaQuery(mobileScreen(theme));
  const [disableDemand, setDisableDemand] = useState(false)
  const [disableSupply, setDisableSupply] = useState(false)

  const demandCurveResponsive = () => {
    console.log("isMobile", isMobile)
    if (isMobile)
      return question.demand === "normal" ? <DemandCurveMobile
        {...otherProps}
        disableDemand={disableDemand}
        setDisableDemand={setDisableDemand}
        disableSupply={disableSupply}
        setDisableSupply={setDisableSupply}
      /> : question.demand === "steep" ? <DemandCurveMobileSteep
        {...otherProps}
        disableDemand={disableDemand}
        setDisableDemand={setDisableDemand}
        disableSupply={disableSupply}
        setDisableSupply={setDisableSupply}
      /> : <DemandCurveMobileFlat
        {...otherProps}
        disableDemand={disableDemand}
        setDisableDemand={setDisableDemand}
        disableSupply={disableSupply}
        setDisableSupply={setDisableSupply}
      />
    else if (isEmulator)
      return <DemandCurveEmulator
        {...otherProps}
        disableDemand={disableDemand}
        setDisableDemand={setDisableDemand}
        disableSupply={disableSupply}
        setDisableSupply={setDisableSupply}
      />
    else
      return question.demand === "normal" ? <DemandCurve
        {...otherProps}
        disableDemand={disableDemand}
        setDisableDemand={setDisableDemand}
        disableSupply={disableSupply}
        setDisableSupply={setDisableSupply}
      /> : question.demand === "steep" ? <DemandCurveSteep
        {...otherProps}
        disableDemand={disableDemand}
        setDisableDemand={setDisableDemand}
        disableSupply={disableSupply}
        setDisableSupply={setDisableSupply}
      />  : <DemandCurveFlat
      {...otherProps}
      disableDemand={disableDemand}
      setDisableDemand={setDisableDemand}
      disableSupply={disableSupply}
      setDisableSupply={setDisableSupply}
    /> 
  }

  const supplyCurveResponsive = () => {
    if (isMobile)
      return question.supply === "normal" ? <SupplyCurveMobile
        {...otherProps}
        disableDemand={disableDemand}
        setDisableDemand={setDisableDemand}
        disableSupply={disableSupply}
        setDisableSupply={setDisableSupply}
      /> : question.supply === "steep" ? <SupplyCurveMobileSteep
        {...otherProps}
        disableDemand={disableDemand}
        setDisableDemand={setDisableDemand}
        disableSupply={disableSupply}
        setDisableSupply={setDisableSupply}
      /> : <SupplyCurveMobileFlat
        {...otherProps}
        disableDemand={disableDemand}
        setDisableDemand={setDisableDemand}
        disableSupply={disableSupply}
        setDisableSupply={setDisableSupply}
      />
    else if (isEmulator)
      return <SupplyCurveEmulator
        {...otherProps}
        disableDemand={disableDemand}
        setDisableDemand={setDisableDemand}
        disableSupply={disableSupply}
        setDisableSupply={setDisableSupply}
      />
    else
      return question.supply === "normal" ?  <SupplyCurve
        {...otherProps}
        disableDemand={disableDemand}
        setDisableDemand={setDisableDemand}
        disableSupply={disableSupply}
        setDisableSupply={setDisableSupply}
      /> : question.supply === "steep" ?  <SupplyCurveSteep
        {...otherProps}
        disableDemand={disableDemand}
        setDisableDemand={setDisableDemand}
        disableSupply={disableSupply}
        setDisableSupply={setDisableSupply}
      /> : <SupplyCurveFlat
        {...otherProps}
        disableDemand={disableDemand}
        setDisableDemand={setDisableDemand}
        disableSupply={disableSupply}
        setDisableSupply={setDisableSupply}
      />
  }

  return (
    <Grid className={classes.graphLines}>
      <img src={price} className={classes.graphYLable} />
      {demandCurveResponsive()}
      {supplyCurveResponsive()}
      <img src={quantity} className={classes.graphXLable} />
    </Grid>
  )
}

export default withStyles(styles)(LineDotBothHandler)
